import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Provider from './Components/OnlineOrdering/Home/Pages/Store/Store';
import { CartProvider } from './Components/OnlineOrdering/Home/Cart';
import NewProvider from './Components/OnlineOrdering/Home/Pages/Store/newStore';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider>
      <NewProvider>

        <CartProvider>
          <App />
        </CartProvider>
      </NewProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
